/*
  Collection-aware breadcrumbs (capture side).

  Product links use canonical /products/{handle} URLs, so Shopify no longer
  knows which collection a customer came from. When a product link inside a
  product card tagged with [data-breadcrumb-collection] is clicked, store a
  short-lived, single-use record for that product. snippets/breadcrumbs.liquid
  consumes and validates it on the product page.
*/
(function () {
  var PENDING_KEY = 'missia:breadcrumb:pending';
  var quickViewCollection = null;

  function storage() {
    try {
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  function productHandle(link) {
    if (link.origin !== window.location.origin) return null;
    var match = link.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setPending(product, collection) {
    var store = storage();
    if (!store) return;
    try {
      if (product && collection) {
        store.setItem(PENDING_KEY, JSON.stringify({ product: product, collection: collection, time: Date.now() }));
      } else {
        store.removeItem(PENDING_KEY);
      }
    } catch (e) {}
  }

  function cardCollection(el) {
    var card = el.closest('[data-breadcrumb-collection]');
    return card ? card.getAttribute('data-breadcrumb-collection') : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      // Quick view opens a modal, not a page: only remember the card's
      // collection in memory for the modal's "View product details" link.
      var quickViewTrigger = e.target.closest('.show-product-quickview, [data-product-url]');
      if (quickViewTrigger) {
        quickViewCollection = cardCollection(quickViewTrigger);
        return;
      }

      var link = e.target.closest('a[href]');
      if (!link) return;

      var product = productHandle(link);
      if (!product) return;

      // New tabs/windows don't share this navigation; never leave a record behind.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') {
        setPending(null);
        return;
      }

      var collection = link.classList.contains('quick-view-view-product-details-link')
        ? quickViewCollection
        : cardCollection(link);

      setPending(product, collection);
    },
    true
  );
})();
